
export const platformUsedOption = [
	{ value: 'gsbsoirika', label: 'GSB Soirika' },
	{ value: 'shaadi.com', label: 'Shaadi.com' },
	{ value: 'jeevansaathi.com', label: 'jeevansaathi.com' },
	{ value: 'offline', label: 'Offline' },
	{ value: 'Other', label: 'Other' },
];